export class ConnectDevice {
  id: string;
  serialNo: string;
  model: string;
  token: string;
  connectedBy: string;
  isValid: boolean;
  isDeleted: boolean;
}